<template>
  <div id="banner-box" class="container-fluid">
    <div class="row" id="banner">
      <div
        id="logoBox"
        class="col-2 d-none d-md-flex justify-content-center align-items-center"
      >
        <!-- Left narrow column: to contain the logo, hidden on phones -->
        <img
          src="/assets/logo200.gif"
          class="img-fluid"
          alt="The Wessex Dramas logo"
          id="logo"
        />
      </div>

      <!-- Central column for the main stuff in the banner and nav bar. It should fill the remaining space -->
      <div class="col">
        <!-- this central column splits into two rows -->
        <div class="row" id="titleRow">
          <!-- this row fills the central column giving the title as much room as we can -->
          <div class="col-12 text-center">
            <p id="title">The Wessex Dramas Project</p>
          </div>
        </div>

        <div class="row" id="subTitleAndNav">
          <!-- in this, second row, we have 3 columns -->
          <div
            id="medallionLeft"
            class="col-1 d-none d-xl-block d-flex justify-content-center ribbon"
          >
            <img
              src="/assets/medallion.png"
              alt="a pretty ribbon"
              class="img-fluid ribbon"
              style="padding-right: 0"
            />
          </div>
          <div class="col text-center">
            <p id="log-line">Thomas Hardy's stories as films and podcasts</p>
            <PrimaryNav />
          </div>
          <div
            id="medallionRight"
            class="col-1 d-none d-xl-block d-flex justify-content-center ribbon"
          >
            <img
              src="/assets/medallion.png"
              alt="a pretty ribbon"
              class="img-fluid ribbon"
              style="padding-right: 0"
            />
          </div>
        </div>
        <!-- end of the second row in the central column -->
      </div>
      <!-- end of that top-level central column -->

      <div
        class="col-2 d-none d-md-flex justify-content-center align-items-center"
      >
        <!-- Third column (top level). No content, just to balance the logo placed on the left hand side -->
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryNav from "@/components/PrimaryNav.vue";

export default {
  name: "BannerBox",
  components: { PrimaryNav },
};
</script>

<style lang="scss">
@use "@/assets/styles/livery" as *;

#banner-box {
  background-color: $colour-banner-background;
  color: $colour-banner-primary-text;
  padding-top: $margin-furniture;
  padding-bottom: $margin-furniture;

  #banner {
    font-family: branded-font, "Times New Roman", Times, serif;
    padding: 4px 0;
    border-color: $colour-page-background;
    border-top: $pin-stripe-width $pin-stripe-style;
    border-bottom: $pin-stripe-width $pin-stripe-style;
    text-align: center;
    display: flex !important;
    align-items: center;

    img {
      padding: 0;
      max-height: 9em;
    }

    #title {
      /* With zero padding given to the col that contains this, 5em seems to give 1 line on the iPad */
      font-size: 5em;
      font-weight: bold;
      text-align: center;
      line-height: 1em;
      margin-bottom: 1.25rem;
    }

    #log-line {
      font-size: 1.5em;
      line-height: 1.1em;
      color: $colour-banner-secondary-text;
      margin-bottom: 0; // get rid of the margin inherited from the P tag

      img {
        position: unset;
        width: auto;
        margin: auto;
        height: 1.25em;
      }
    }
  }

  .router-link-active {
    font-style: italic;
    text-decoration: none !important;
  }

  nav {
    a {
      color: $colour-banner-primary-text;
      font-weight: 700;
      font-size: 2em;
    }

    .navbar-toggler {
      border-color: $colour-page-background;
    }
  }
}
</style>
